































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { zip } from 'rxjs';
import { cloneDeep } from 'lodash';
import { IType } from '@/interfaces/sieves';
import BaseComponent from '@/components/base-component.vue';
import { IProperty } from '@/interfaces/rules-engine';
import * as service from '@/services/rules-engine';
import InputMoney from '@/components/UI/input-money.vue';
import * as sieveService from '@/services/sieves';
import { sortKey } from '@/helpers/sort';
import {
  FIELD_TYPE_ID,
  FIELD_TYPE_ENUMERATED,
} from '@/settings/consts/rules-engine';

@Component({
  components: { InputMoney },
})
export default class RulesEngineConditionForm extends BaseComponent {
  @Prop(Boolean)
  public isEdit!: boolean;

  @Prop()
  public editItem: any;

  public properties: IProperty[] = [];

  public entityList: any = [];
  public entityListLoading: boolean = false;
  public fieldsList: any = [];
  public fieldsListLoading: boolean = false;
  public operatorList: any = [];
  public filteredOperatorList: any = [];
  public filteredOperatorListLoading: boolean = false;
  public crivoList: any = [];

  public activeTab: any = 0;
  public showNewCrivoTab: boolean = true;

  public types: IType[] = [];

  public item: any = {
    entidade: null,
    campo: null,
    operador: null,
    descricao: '',
    valor: '',
    isNew: true,
    crivo: null,
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false,
    rules: {
      entity: [(v) => !!v || 'Selecione uma entidade'],
      field: [(v) => !!v || 'Selecione um campo'],
      operator: [(v) => !!v || 'Selecione um operador'],
      type: [(v) => !!v || 'Selecione um tipo'],
      description: [(v) => !!v || 'Digite uma descrição'],
      value: [(v) => !!v || 'Digite um valor'],
      item: [(v) => !!v || 'Selecione um item'],
    },
  };

  @Watch('item.entidade')
  public onModelEntityChange(val: any) {
    this.filterCamposField(val && val.classe);
    this.filteredOperatorList = [];
  }

  @Watch('item.campo')
  public onModelFieldChange(val: any) {
    this.filterOperatorField(val && val.tipo);
  }

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.$refs.form.resetValidation();
    this.item = {
      entidade: null,
      campo: null,
      operador: null,
      descricao: '',
      valor: '',
      isNew: true,
      crivo: null,
    };

    if (!val) {
      return;
    }

    this.item = cloneDeep(this.editItem); // Clones the Prop into the model
    this.activeTab = 0;
    if (!this.item.isNew) {
      this.activeTab = 1;
    }
    this.load();
  }

  public filterCamposField(entidade: string): any {
    this.fieldsList = [];
    this.fieldsListLoading = true;
    service.configurableEntity().subscribe((entities) => {
      this.entityList = entities.sort(sortKey('descricao'));
      const filteredEntity = entities.find((e) => e.classe === entidade);

      if (!!filteredEntity) {
        this.fieldsList = filteredEntity.campos
          .map((campo) => {
            if (
              filteredEntity.classe.indexOf('Insumo') !== -1 &&
              !!campo.unidadeMedida
            ) {
              return {
                ...campo,
                descricao: `${campo.descricao} (${campo.unidadeMedida})`,
              };
            }

            return campo;
          })
          .sort(sortKey('descricao'));
      }

      this.fieldsListLoading = false;
    });
  }

  public filterOperatorField(campo: string): any {
    service.operators().subscribe((operators) => {
      this.operatorList = operators;
      const operatorGroup = operators.find((g) => g.tipo === campo);
      this.filteredOperatorList = !!operatorGroup
        ? operatorGroup.operadores.sort(sortKey('descricao'))
        : [];

      this.item.tipo = campo;
      if (campo === FIELD_TYPE_ID || campo === FIELD_TYPE_ENUMERATED) {
        this.crivoList = (this.item.campo as any).itensIdentificaveis
          .map((i) => ({ id: i.id, label: i.label }))
          .sort(sortKey('label'));
        this.showNewCrivoTab = false;
        this.activeTab = 0;
        this.item.isNew = false;
        return;
      }

      if (!!this.item.isNew) {
        this.activeTab = 0;
      } else {
        this.activeTab = 1;
      }

      this.showNewCrivoTab = true;
      this.crivoList = this.properties
        .filter((i) => i.tipo.tipo === campo)
        .map((i) => ({ id: i.id, label: i.descricao }))
        .sort(sortKey('label'));
    });
  }

  public beforeMount(): void {
    this.load();
  }

  public onSaveClick(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }
    const payload = cloneDeep(this.item); // Clones the Model into the Payload
    if (!payload.isNew) {
      let crivoLabel;
      if (
        payload.campo.tipo === FIELD_TYPE_ID ||
        payload.campo.tipo === FIELD_TYPE_ENUMERATED
      ) {
        const crivo = payload.campo.itensIdentificaveis.find(
          (item) => item.id === payload.crivo.id,
        );

        if (!!crivo) {
          crivoLabel = crivo.label;
        }
      } else {
        const property = this.properties.find((p) => p.id === payload.crivo.id);
        crivoLabel = `${property.descricao} ( ${property.valor} )`;
      }

      payload.crivo.label = crivoLabel;
    }
    this.$emit('save', payload);
    this.$refs.form.resetValidation();
  }

  public onCloseClick(): void {
    const closeAction = () => {
      this.$emit('close');
      this.$refs.form.resetValidation();
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  public onNewCrivoClick(): void {
    this.item.isNew = true;
  }

  public onExistingCrivoClick(): void {
    this.item.isNew = false;
  }

  private load(): void {
    this.entityListLoading = true;
    zip(
      service.configurableEntity(),
      service.operators(),
      sieveService.getSieves(),
      sieveService.getSievesTypes(),
    ).subscribe(([entities, operators, properties, sieveTypes]) => {
      this.types = sieveTypes;
      this.entityList = entities;
      this.operatorList = operators;
      this.properties = properties;
      this.entityListLoading = false;
    });
  }

  isLoading() {
    return this.entityListLoading || this.fieldsListLoading || this.filteredOperatorListLoading;
  }
}
